import { useEffect, useState } from 'react';
import {
  FLOATING_WIDGET_Z_INDEX,
  IFloatingVariantProps,
} from '../FloatingWidget';
import { Button } from 'ui/mobile-ds';
import { useFloatingWidgetContext } from '@/context/FloatingWidgetContext';
import { useSearchParams } from 'react-router-dom';
import { AIStar, CloseFilled } from 'ui/icons';
import { getDimensions } from '@/utils';

const ClaimsBot = ({
  onTriggerClick,
  isHidden,
  isOpen,
}: IFloatingVariantProps) => {
  const { isFloatingWidgetOpen, setIsFloatingWidgetOpen } =
    useFloatingWidgetContext();

  const [searchParams] = useSearchParams();
  const showBotParam = searchParams.get('showBot');
  const [bottom, setBottom] = useState(24);

  const isBotOpen = showBotParam === 'true';

  useEffect(() => {
    if (isBotOpen) {
      setIsFloatingWidgetOpen(true);
    }
  }, [isBotOpen, setIsFloatingWidgetOpen]);

  useEffect(() => {
    const footerDimensions = getDimensions('claims-footer');
    setBottom(
      footerDimensions?.height > 0 ? footerDimensions?.height + 12 : 24
    );
  }, [isHidden]);

  if (isHidden) {
    return null;
  }

  return (
    <div id="cashless-bot-trigger">
      <Button
        style={{
          zIndex: FLOATING_WIDGET_Z_INDEX + 1,
          bottom,
        }}
        prefixIcon={() => (isFloatingWidgetOpen ? <CloseFilled /> : <AIStar />)}
        className="fixed right-6 bottom-6 outline-none py-3 px-4 rounded-full text-sm shadow-md border-2 border-mobile-gray-100 bg-white hover:bg-secondary-50 active:bg-white focus:bg-secondary-50 text-mobile-gray-500 font-semibold min-w-fit gap-0"
        onClick={onTriggerClick}
      >
        <p className="ml-2">{isOpen ? 'Close' : 'I need help'}</p>
      </Button>
    </div>
  );
};

export default ClaimsBot;
